import TemplatePage from "../containers/template_page/template_page";
import BandiPage from "../containers/bandi_page/bandi_page";
import CoursePage from "../containers/course_page/course_page";
import CattedreonlinePage from "../containers/cattedreonline_page/cattedreonline_page";
import TemplatePageLeftContent from "../containers/template_page/template_page_left_content/template_page_left_content";
import NewsPageLeftContent from "../containers/news_page/news_page_left_content";
import EventPageLeftContent from "../containers/event_page/event_page_left_content";
import CoursePageLeftContent from "../containers/course_page/course_page_left_content";
import SitemapPage from "../containers/sitemap_page/sitemap_page";
import EventPage from "../containers/event_page/event_page";
import AgreementPage from "../containers/convenzioni_page/convenzioni_page";
import SummerCoursePage from "../containers/summer_course_page/summer_course_page";
import FacultyProfilePage from "../containers/faculty_profile_page/faculty_profile_page";

export const PAGES_CLASSES: Map<string, any> = new Map([
    ["/page/", TemplatePage],
    ["/news/", TemplatePage],
    ["/eventi/", EventPage],
    ["/avvisi/", TemplatePage],
    ["/bandi/", BandiPage],
    ["/course/", CoursePage],
    ["/convenzione/", AgreementPage],
    ["/cattedreonline/corso/", CattedreonlinePage],
    ["/faculty/", FacultyProfilePage],
    ["/sitemap-page", SitemapPage],
    ["/summer_course/", SummerCoursePage]
]);

export const LEFT_CONTENT_CLASSES: Map<string, any> = new Map<string, any>([
    ["/page/", TemplatePageLeftContent],
    ["/news/", NewsPageLeftContent],
    ["/eventi/", EventPageLeftContent],
    ["/avvisi/", NewsPageLeftContent],
    ["/bandi/", TemplatePageLeftContent],
    ["/course/", CoursePageLeftContent],
    ["/convenzione/", TemplatePageLeftContent],
    ["/cattedreonline/corso/", TemplatePageLeftContent],
    ["/sitemap-page", TemplatePageLeftContent]
]);
